var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":""}},_vm._l((this.$store.state.pages[0].BCDBWidgets),function(w){return _c('v-col',{key:w.id,attrs:{"cols":w.cols,"sm":"1.5"}},[_c('WidgetController',{attrs:{"widget":w}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }